angular.module('wbDashboard').controller('PlansDetailFeatureControllerAurea', ['$scope', 'Track', function ($scope, Track) {

    $scope.feature = {};

    //data only shared on this page and it's children to override methods in it in children
    $scope.localData = {};

    $scope.tabs = {
        active: null,
        data: {
            "detail" : {label: "Overview", value: "detail", callbacks: {} },
            "about" : {label: "About", value: "about", callbacks: {} },
        }
    };

    $scope.$watch('plan', function(plan) {
        if (plan) {
            angular.forEach(plan.features, function(feature) {
                if (feature.slug === $scope.$stateParams.fslug) {
                    $scope.feature = feature;
                    $scope.setFeatureTabs();
                }
            });

            Track.send("Page Viewed", "Services", {page: $scope.feature.display_name + " View", package: "On", feature: $scope.feature.enabled?"On":"Off"});

        }
    });

    $scope.setFeatureTabs = function() {
        $scope.tabs.active = $scope.localData.initialTab();
        $scope.tabs.data.detail.hidden = $scope.localData.hideDetail();
    };

    $scope.localData.initialTab = function() {
        return $scope.feature.enabled ? "detail" : "about";
    };
    $scope.localData.hideDetail = function() {
        return !$scope.feature.enabled;
    };

}]);
